/* eslint-disable react/no-unused-prop-types */
import { useEffect, useRef, useState } from 'react';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Input,
  ListGroup,
  ListGroupItem,
  Row,
  Table,
} from 'reactstrap';
import { useQuery } from 'react-query';
import {
  CircularProgress,
  Collapse,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
} from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';
import toast from 'react-hot-toast';
import Select from 'react-select';
import UserSmallHeader from 'components/Headers/UserSmallHeader';
import api from 'services/api';
import Proposta from 'models/Proposta';
import AutocompletePessoa from 'components/AutcompletePessoa';
import Pessoa from 'models/Pessoa';
import {
  FaEraser,
  FaCopy,
  FaInfoCircle,
  FaSearch,
  FaArrowDown,
  FaArrowUp,
} from 'react-icons/fa';
import { PropostaVersao } from 'models/PropostaVersao';
import { PropostaStatus } from 'models/PropostaStatus';
import {
  List,
  AutoSizer,
  CellMeasurer,
  CellMeasurerCache,
} from 'react-virtualized';
import { error } from 'highcharts';
import AutocompleteUsuario from 'components/AutocompleteUsuarios';
import Usuario from 'models/Usuario';
import AutoCompleteGeneric from 'components/AutoCompleteGeneric';

interface Dados {
  proposta_id: number;
  versao_id: number;
  versao: number;
  statusId: number;
  codigo_oportunidade_domsge: string;
  pessoa_id: number;
  pessoa_gnf_id: number;
  createdAt: number;
}

interface buscarDadosProps {
  pPessoa: string;
  pProposta: string;
  pGnf: string;
  pStatus: string;
  pCidade: string;
  pEstado: string;
  pUsuarioId: number | null;
  pFuncao: string;
  pEmpresa: string;
  pSupervisor: string;
}

interface PropostaVersoes {
  created_at: string;
  indicPermiteModificar: boolean;
  proposta_versao_observacao: string | null;
  statusId: number;
  status_descricao: string;
  valor_final: number;
  valor_frete: number;
  valor_itens: number;
  valor_servico: number;
  versao: number;
  versao_id: number;
}

interface PropostaSQL {
  created_at: string;
  indicPermiteModificar: boolean;
  proposta_versao_observacao: string | null;
  statusId: number;
  status_descricao: string;
  valor_final: number;
  valor_frete: number;
  valor_itens: number;
  valor_servico: number;
  versao: number;
  versao_id: number;
  codigoDomsge: string;
  codigo_oportunidade_domsge: string;
  empresa: string;
  municipio: string;
  pessoa_cargo_desc: string;
  pessoa_domsge: number;
  pessoa_gnf_id: number;
  pessoa_id: number;
  pessoa_interno: boolean;
  pessoa_razao: string;
  pessoa_sup_cargo_desc: string;
  pessoa_sup_razao: string;
  pgnf_codigo_domsge: string;
  pgnf_razao_social: string;
  proposta_id: number;
  razaoSocial: string;
  uf: string;
  usuario_nome: string;
  versoes: PropostaVersoes[];
}

export default function Propostas(): JSX.Element {
  const history = useHistory();
  const cache = useRef(
    new CellMeasurerCache({
      fixedWidth: true,
      defaultHeight: 250,
    }),
  );
  const [propostas, setPropostas] = useState<Proposta[]>([]);

  const [codigoOportunidade, setCodigoOportunidade] = useState('');
  const [codigoProposta, setCodigoProposta] = useState('');
  const [pessoaSelecionada, setPessoaSelecionada] = useState<Pessoa | null>(
    null,
  );
  const [listaStatus, setListaStatus] = useState<PropostaStatus[]>([]);
  const [cidade, setCidade] = useState('');
  const [estado, setEstado] = useState('');
  const [usuarioId, setUsuarioId] = useState<number | null>(null);
  const [funcao, setFuncao] = useState('');
  const [empresa, setEmpresa] = useState('');
  const [supervisor, setSupervisor] = useState('');

  const [usuarioSelecionado, setUsuarioSelecionado] = useState<Usuario | null>(
    null,
  );
  const [isOpen, setIsOpen] = useState(false);

  const [statusIdFiltrar, setStatusIdFiltrar] = useState<number>(0);
  const [statusSelecionado, setStatusSelecionado] = useState<any>([] as any);
  const [firstLoadComplete, setFirstLoadComplete] = useState<boolean>(false);
  const [startFirstSearch, setStartFirstSearch] = useState<boolean>(false);

  const { data: queryListaStatus } = useQuery(
    `proposta-status`,
    async () => {
      async function getStatus(): Promise<PropostaStatus[]> {
        const response = await api.get('/proposta/status');
        return response.data;
      }

      const dataStatus = await getStatus();
      return dataStatus;
    },
    { staleTime: 1000 * 60 * 10 },
  );

  const [dados, setDados] = useState<PropostaSQL[]>([]);
  const [pagina, setPagina] = useState(1);
  const [temMais, setTemMais] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  async function buscarDados(
    paginaAtual: number,
    {
      pPessoa,
      pProposta,
      pGnf,
      pStatus,
      pCidade,
      pEstado,
      pUsuarioId,
      pFuncao,
      pEmpresa,
      pSupervisor,
    }: buscarDadosProps,
  ) {
    const toastBusca = toast.loading('Buscando...');
    try {
      setIsLoading(true);
      setDados([]);

      const pessoa = `&codigoCliente=${pPessoa}`;
      const proposta = `&codigoProposta=${pProposta}`;
      const gnf = `&codigoGNF=${pGnf}`;
      const status = `&status=${pStatus}`;
      const vCidade = `&cidade=${pCidade}`;
      const vEstado = `&estado=${pEstado}`;
      const vUsuarioId = `&usuarioId=${pUsuarioId}`;
      const vFuncao = `&funcao=${pFuncao}`;
      const vEmpresa = `&empresa=${pEmpresa}`;
      const vSupervisor = `&supervisor=${pSupervisor}`;

      const response = await api.get(
        `/proposta?page=${0}${pessoa}${gnf}${status}${proposta}${vCidade}${vEstado}${vUsuarioId}${vFuncao}${vEmpresa}${vSupervisor}`,
      );

      localStorage.setItem('propostas_filtros_pessoa', pPessoa);
      localStorage.setItem('propostas_filtros_gnf', pGnf);
      localStorage.setItem('propostas_filtros_proposta', pProposta);
      localStorage.setItem('propostas_filtros_status', pStatus);
      setDados(response.data);
      // const newDados = [...response.data];
      // setDados(newDados);
      setTemMais(response.data.length > 0);

      Swal.close();
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: 'Ops!',
        text: err?.response?.data?.message,
      });
    } finally {
      setIsLoading(false);
      toast.dismiss(toastBusca);
    }
  }

  function formataMoeda(valor?: number | null) {
    if (valor === null || valor === undefined) {
      return '';
    }
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(valor || 0);
  }

  function setSwal(mensagem?: string, type = 'info') {
    if (!mensagem) {
      Swal.close();

      return;
    }

    if (type === 'info') {
      Swal.fire({
        icon: 'info',
        text: mensagem,
        allowOutsideClick: false,
        showConfirmButton: false,
      });

      return;
    }

    if (type === 'error') {
      Swal.fire({
        icon: 'error',
        title: 'Ops!',
        html: mensagem,
      });
    }
  }

  async function duplicar(id: number): Promise<any> {
    const retornoConfiguracoes = await api.get(
      `/proposta/versao/${id}/configuracoes`,
      {},
    );

    if (retornoConfiguracoes && retornoConfiguracoes.data.length) {
      setSwal('Duplicando versão da proposta...');

      // disparar a duplicação do item principal
      const retorno = await api.post(`/proposta/versao/${id}/duplicar`, {});

      const total = retornoConfiguracoes.data.length;
      let processados = 0;
      const orcamentosOriginais = [];
      const orcamentosNovos = [];
      const objOrcamentos: {
        original: number;
        novo: number;
      }[] = [];

      // eslint-disable-next-line no-restricted-syntax
      for await (const configuracao of retornoConfiguracoes.data) {
        try {
          orcamentosOriginais.push(configuracao.orcamentoId);
          processados += 1;
          setSwal(
            `Duplicando configuração #${configuracao.orcamentoId}. ${processados} de ${total} configurações processadas`,
          );

          const novoId = await api.post(
            `/proposta/versao/${retorno.data.id}/duplicar/${configuracao.orcamentoId}`,
            {},
          );

          orcamentosNovos.push(novoId.data);

          objOrcamentos.push({
            original: configuracao.orcamentoId,
            novo: novoId.data,
          });
        } catch (e) {
          console.log('erro: ', e);
          setSwal(`Erro: ${e}.`);
        }
      }

      setSwal(`Concluindo processo de duplicação`);
      await api.post(`/proposta/versao/duplicar-alternados`, {
        orcamentosOriginaisId: orcamentosOriginais,
        orcamentosNovosId: orcamentosNovos,
        orcamentos: objOrcamentos,
      });

      // setSwal(`Concluindo processo de duplicação`);
      const retornoFinal = await api.post(
        `/proposta/versao/${retorno.data.id}/duplicar/finalizacao`,
        {},
      );

      return {
        sucesso: true,
        id: retornoFinal.data.id,
        conteudo: retornoFinal.data,
      };
    }

    return {
      sucesso: false,
    };
  }

  async function duplicarRegistro(
    proposta: PropostaSQL,
    registro: PropostaVersoes,
  ) {
    const isAlternadoConcluido = await api.get(
      `/proposta/versao/valida-alternado-concluido/${registro.versao_id}`,
    );

    if (!isAlternadoConcluido.data) {
      Swal.fire({
        icon: 'error',
        title: 'Ops!',
        text: 'Todas as configurações alternadas precisam estar concluídas para duplicar a proposta.',
      });
      return;
    }

    /* async function duplicar(): Promise<any> {
      setSwal('Duplicando versão da proposta...');

      const retorno = await api.post(
        `/proposta/versao/${registro.versao_id}/duplicar`,
        {},
      );
      return retorno.data;
    } */

    async function calculaPrecificacao(
      orcamentoId: number,
      orcamentoParteId: number,
    ): Promise<void> {
      Swal.fire({
        icon: 'info',
        text: `Calculando precificação da configuração #${orcamentoId}...`,
        allowOutsideClick: false,
        showConfirmButton: false,
      });
      await api.post('/integracao/precificacao/calculo', {
        orcamentoId,
        orcamentoParteId,
      });
    }

    async function reprocessarVersao(versaoId: number): Promise<any> {
      setSwal('Reprocessando e recalculando versão da proposta');
      await api.post(`/proposta/versao/${versaoId}/reprocessar`, {
        frete: true,
        servico: true,
        itens: true,
        itensAvulsos: true,
      });
    }

    async function executarProcessoDuplicacao() {
      const retorno = await duplicar(registro.versao_id);

      if (!retorno.sucesso) {
        Swal.fire({
          icon: 'error',
          title: 'Ops!',
          html: 'Não foi possível duplicar o registro.',
        });

        return;
      }

      await reprocessarVersao(retorno.id);

      setSwal();

      toast.success('Registro duplicado. Navegando para ele...');

      const propostaNovo = await api.get(`/proposta/${proposta.proposta_id}`);

      history.push({
        pathname: '/admin/proposta',
        state: {
          proposta: propostaNovo.data,
          propostaVersao: propostaNovo.data.PropostaVersao?.find(
            (item: any) => item.id === retorno.id,
          ),
        },
      });
    }

    Swal.fire({
      title: `Deseja duplicar as informações da versão ${registro.versao} em uma nova versão da proposta #${proposta.proposta_id}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `Sim, duplicar`,
      confirmButtonColor: '#d33',
      cancelButtonText: `Não`,
    }).then(async result => {
      if (result.isConfirmed) {
        await executarProcessoDuplicacao();
      }
    });
  }

  /**
   * onClick={() => {
                                                      history.push({
                                                        pathname:
                                                          '/admin/proposta',
                                                        state: {
                                                          proposta,
                                                          propostaVersao,
                                                        },
                                                      });
                                                    }}
   */

  async function navegarProposta(proposta_id: any, pVersaoId: number) {
    toast.loading('Buscando informações e navegando para Proposta');
    const proposta = await api.get(`/proposta/${proposta_id}`);
    const propostaVersao = await api.get(`/proposta/versao/${pVersaoId}`);

    history.push({
      pathname: '/admin/proposta',
      state: { proposta: proposta.data, propostaVersao: propostaVersao.data },
    });
    toast.dismiss();
  }

  useEffect(() => {
    sessionStorage.setItem('TelaConfig', '');
  }, []);

  useEffect(() => {
    if (queryListaStatus) {
      setListaStatus(queryListaStatus);

      setStatusSelecionado(
        queryListaStatus
          .filter(item => item.indicFiltroDefaultLista === true)
          .map((item: PropostaStatus) => {
            return { label: item.descricao, value: item.id };
          }),
      );

      setFirstLoadComplete(true);
    }
  }, [queryListaStatus]);

  function handleBuscaPropostas() {
    cache.current = new CellMeasurerCache({
      fixedWidth: true,
      defaultHeight: 100,
    });

    buscarDados(0, {
      pGnf: codigoOportunidade,
      pPessoa: String(pessoaSelecionada?.id ?? ''),
      pProposta: codigoProposta,
      pStatus:
        statusSelecionado && statusSelecionado.length > 0
          ? statusSelecionado.map((item: any) => item.value)?.join(',')
          : '',
      pCidade: cidade,
      pEstado: estado,
      pUsuarioId: usuarioId,
      pFuncao: funcao,
      pEmpresa: empresa,
      pSupervisor: supervisor,
    });
  }

  async function getPessoa(id: number): Promise<Pessoa> {
    const response = await api.get(`/pessoa/${id}`);
    return response.data;
  }

  async function checkSavedParams() {
    const pPessoa = localStorage.getItem('propostas_filtros_pessoa');
    const pGnf = localStorage.getItem('propostas_filtros_gnf');
    const pProposta = localStorage.getItem('propostas_filtros_proposta');
    const pStatus = localStorage.getItem('propostas_filtros_status');

    if (pGnf) setCodigoOportunidade(String(pGnf ?? ''));

    if (pProposta) setCodigoProposta(String(pProposta ?? ''));

    if (pPessoa) {
      const pessoa = await getPessoa(Number(pPessoa));
      setPessoaSelecionada(pessoa);
    }
    if (pStatus && pStatus.split(',')?.length > 0) {
      setStatusSelecionado(
        listaStatus
          .filter(item => pStatus.split(',').includes(String(item.id)))
          .map((item: PropostaStatus) => {
            return { label: item.descricao, value: item.id };
          }),
      );
    }

    setStartFirstSearch(true);
  }

  useEffect(() => {
    if (firstLoadComplete === true) {
      checkSavedParams();
    }
  }, [firstLoadComplete]);

  useEffect(() => {
    if (startFirstSearch === true) {
      buscarDados(0, {
        pGnf: codigoOportunidade,
        pPessoa: String(pessoaSelecionada?.id ?? ''),
        pProposta: codigoProposta,
        pStatus:
          statusSelecionado && statusSelecionado.length > 0
            ? statusSelecionado.map((item: any) => item.value)?.join(',')
            : '',
        pCidade: cidade,
        pEstado: estado,
        pUsuarioId: usuarioId,
        pFuncao: funcao,
        pEmpresa: empresa,
        pSupervisor: supervisor,
      });
    }
  }, [startFirstSearch]);

  function handleLimparFiltros() {
    cache.current = new CellMeasurerCache({
      fixedWidth: true,
      defaultHeight: 100,
    });

    setCodigoOportunidade('');
    setCodigoProposta('');
    setPessoaSelecionada(null);
    setStatusSelecionado(
      listaStatus
        .filter(item => item.indicFiltroDefaultLista === true)
        .map((item: PropostaStatus) => {
          return { label: item.descricao, value: item.id };
        }),
    );
    setCidade('');
    setEstado('');
    setUsuarioSelecionado(null);
    setUsuarioId(null);
    setFuncao('');
    setEmpresa('');
    setSupervisor('');

    buscarDados(0, {
      pGnf: '',
      pPessoa: '',
      pProposta: '',
      pStatus: listaStatus
        .filter(item => item.indicFiltroDefaultLista === true)
        .map((item: PropostaStatus) => item.id)
        .join(','),
      pCidade: '',
      pEstado: '',
      pUsuarioId: null,
      pFuncao: '',
      pEmpresa: '',
      pSupervisor: '',
    });
  }

  const fetchUsuarios = async (inputValue: string): Promise<Usuario[]> => {
    const response = await api.get('/usuario/buscar', {
      params: { search: inputValue },
    });
    return response.data;
  };

  const fetchPessoas = async (inputValue: string): Promise<Pessoa[]> => {
    const limitarResultados = true;
    const response = await api.get('/pessoa', {
      params: { search: inputValue, limitarResultados },
    });
    return response.data;
  };

  return (
    <>
      <UserSmallHeader />
      <Card>
        <CardHeader>
          <h5 className="h3 mb-0">Propostas</h5>
        </CardHeader>

        <Card className="shadow pt-3 pb-2 px-2 mt-1 mb-0 mx-1">
          <Row>
            <Col sm="5">
              <Row>
                <Col sm="6" className="mb-2">
                  <TextField
                    className="w-100"
                    size="small"
                    type="text"
                    label="GNF"
                    InputLabelProps={{ style: { fontSize: 13 } }}
                    variant="outlined"
                    disabled={isLoading}
                    value={codigoOportunidade}
                    onChange={event =>
                      setCodigoOportunidade(event.target.value)
                    }
                    InputProps={{
                      endAdornment: codigoOportunidade && (
                        <InputAdornment position="end">
                          <IconButton
                            size="small"
                            onClick={() => setCodigoOportunidade('')}
                            edge="end"
                          >
                            x
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Col>

                <Col sm="6" className="mb-2">
                  <TextField
                    className="w-100"
                    size="small"
                    type="text"
                    label="Proposta"
                    InputLabelProps={{ style: { fontSize: 13 } }}
                    variant="outlined"
                    disabled={isLoading}
                    value={codigoProposta}
                    onChange={event => setCodigoProposta(event.target.value)}
                    InputProps={{
                      endAdornment: codigoProposta && (
                        <InputAdornment position="end">
                          <IconButton
                            size="small"
                            onClick={() => setCodigoProposta('')}
                            edge="end"
                          >
                            x
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Col>
                <Col sm="12" className="mb-2">
                  {/**
*
                  <AutocompletePessoa
                    onChange={(_, newValue) =>
                      setPessoaSelecionada(newValue ?? ({} as Pessoa))
                    }
                    pessoaSelecionada={pessoaSelecionada}
                    limitarPorConfiguracao
                    disabled={isLoading}
                  />

                  */}
                  <AutoCompleteGeneric<Pessoa>
                    label="Cliente"
                    selectedItem={pessoaSelecionada}
                    onChange={(_, newValue) => setPessoaSelecionada(newValue)}
                    fetchOptions={fetchPessoas}
                    getOptionLabel={pessoa =>
                      `${pessoa.codigoDomsge} - ${pessoa.razaoSocial}`
                    }
                  />
                </Col>
              </Row>
            </Col>
            <Col sm="7">
              <Row>
                <Col>
                  <Select
                    closeMenuOnSelect={false}
                    placeholder="Selecione os Status"
                    isMulti
                    options={listaStatus.map((item: PropostaStatus) => {
                      return { label: item.descricao, value: item.id };
                    })}
                    value={statusSelecionado}
                    isDisabled={isLoading}
                    onChange={(e: any) => {
                      setStatusSelecionado(e);
                    }}
                    styles={{
                      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                      // @ts-ignore
                      menu: provided => ({
                        ...provided,
                        backgroundColor: '#ffffff', // Define a cor de fundo do menu
                        zIndex: 9999, // Garante que o menu fique acima de outros elementos
                      }),
                      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                      // @ts-ignore
                      option: (provided, state) => ({
                        ...provided,
                        backgroundColor: state.isSelected
                          ? '#f0f0f0'
                          : 'transparent', // Define fundo para a opção selecionada
                        color: state.isSelected ? '#000000' : '#333', // Define a cor do texto das opções
                      }),
                    }}
                  />
                </Col>
                <Col sm="2" className="mb-3 d-flex mr-4">
                  <Button
                    className="btn-icon btn-2"
                    color="primary"
                    type="button"
                    disabled={isLoading}
                    onClick={() => handleBuscaPropostas()}
                  >
                    <FaSearch />
                  </Button>
                  <Button
                    className="btn-icon btn-2 mr-2"
                    color="danger"
                    type="button"
                    title="Limpar os filtros para o padrão"
                    // outline
                    disabled={isLoading}
                    onClick={() => handleLimparFiltros()}
                  >
                    <FaEraser />
                  </Button>
                </Col>
              </Row>

              <Button
                className="btn-icon btn-sm mt-1"
                color="primary"
                type="button"
                disabled={isLoading}
                onClick={() => setIsOpen(prev => !prev)}
              >
                {isOpen ? 'Esconder filtros' : 'Mostrar filtros'}
              </Button>
              <Collapse in={isOpen} timeout="auto" unmountOnExit>
                <Row className="mt-2">
                  <Col sm="4" className="mb-2">
                    <TextField
                      className="w-100"
                      size="small"
                      type="text"
                      label="Cidade"
                      InputLabelProps={{ style: { fontSize: 13 } }}
                      variant="outlined"
                      disabled={isLoading}
                      value={cidade}
                      onChange={event => setCidade(event.target.value)}
                      InputProps={{
                        endAdornment: cidade && (
                          <InputAdornment position="end">
                            <IconButton
                              size="small"
                              onClick={() => setCidade('')}
                              edge="end"
                            >
                              x
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Col>
                  <Col sm="2" className="mb-2">
                    <TextField
                      className="w-100"
                      size="small"
                      type="text"
                      label="Estado"
                      InputLabelProps={{ style: { fontSize: 13 } }}
                      variant="outlined"
                      disabled={isLoading}
                      value={estado}
                      onChange={event => setEstado(event.target.value)}
                      InputProps={{
                        endAdornment: estado && (
                          <InputAdornment position="end">
                            <IconButton
                              size="small"
                              onClick={() => setEstado('')}
                              edge="end"
                            >
                              x
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Col>

                  <Col sm="6" className="mb-2">
                    {/**
                     *
                    <AutocompleteUsuario
                    onChange={(_, newValue) => {
                      console.log('Usuário selecionado:', newValue);
                      setUsuarioSelecionado(newValue);
                      setUsuarioId(Number(newValue?.id));
                    }}
                    usuarioSelecionado={usuarioSelecionado}
                    labelDescricao="Usuário"
                    limitarPorConfiguracao
                    disabled={isLoading}
                    />
                    */}
                    <AutoCompleteGeneric<Usuario>
                      label="Usuário"
                      selectedItem={usuarioSelecionado}
                      onChange={(_, newValue) => {
                        // console.log('Usuário selecionado:', newValue);
                        setUsuarioSelecionado(newValue);
                        setUsuarioId(Number(newValue?.id));
                      }}
                      fetchOptions={fetchUsuarios}
                      getOptionLabel={user => `${user.id} - ${user.nome}`}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col sm="4" className="mb-2">
                    <TextField
                      className="w-100"
                      size="small"
                      type="text"
                      label="Função"
                      InputLabelProps={{ style: { fontSize: 13 } }}
                      variant="outlined"
                      disabled={isLoading}
                      value={funcao}
                      onChange={event => setFuncao(event.target.value)}
                      InputProps={{
                        endAdornment: funcao && (
                          <InputAdornment position="end">
                            <IconButton
                              size="small"
                              onClick={() => setFuncao('')}
                              edge="end"
                            >
                              x
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Col>
                  <Col sm="4" className="mb-2">
                    <TextField
                      className="w-100"
                      size="small"
                      type="text"
                      label="Empresa"
                      InputLabelProps={{ style: { fontSize: 13 } }}
                      variant="outlined"
                      disabled={isLoading}
                      value={empresa}
                      onChange={event => setEmpresa(event.target.value)}
                      InputProps={{
                        endAdornment: empresa && (
                          <InputAdornment position="end">
                            <IconButton
                              size="small"
                              onClick={() => setEmpresa('')}
                              edge="end"
                            >
                              x
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Col>
                  <Col sm="4" className="mb-2">
                    <TextField
                      className="w-100"
                      size="small"
                      type="text"
                      label="Nome do superior"
                      InputLabelProps={{ style: { fontSize: 13 } }}
                      variant="outlined"
                      disabled={isLoading}
                      value={supervisor}
                      onChange={event => setSupervisor(event.target.value)}
                      InputProps={{
                        endAdornment: supervisor && (
                          <InputAdornment position="end">
                            <IconButton
                              size="small"
                              onClick={() => setSupervisor('')}
                              edge="end"
                            >
                              x
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Col>
                </Row>
              </Collapse>
            </Col>
          </Row>
        </Card>

        <CardBody className="p-0 pr-1 pl-1" style={{ background: '#ebf3fa' }}>
          {isLoading ? (
            <Row>
              <Col className="text-center mb-4 mt-4">
                <CircularProgress />
              </Col>
            </Row>
          ) : (
            <>
              <ListGroup flush>
                {/*
                  <InfiniteScroll
                  dataLength={dados.length}
                  next={carregarMais}
                  hasMore={temMais}
                  loader={<h4>Carregando...</h4>}
                  scrollThreshold={0.9}
                  height="80vh"
                  scrollableTarget="list-container"
                  style={{ overflow: 'hidden' }}
                >
                  */}
                {dados && dados.length > 0 && (
                  <div
                    id="list-container"
                    style={{
                      width: '100%',
                      height: '70vh',
                      overflow: 'hidden',
                    }}
                  >
                    {/**
                       *
                      <ListaPropostas dados2={dados} />
                      */}

                    <AutoSizer>
                      {({ height, width }) => (
                        <List
                          height={height}
                          width={width}
                          rowCount={dados.length}
                          rowHeight={cache.current.rowHeight}
                          // rowHeight={250}
                          deferredMeasurementCache={cache.current}
                          rowRenderer={({ index, key, style, parent }) => {
                            const proposta: PropostaSQL = dados[index];

                            const propostaVersoes: PropostaVersoes[] =
                              proposta.versoes;

                            const versoesStatus =
                              propostaVersoes?.filter(
                                (prop: any) => Number(prop?.statusId) === 3,
                              ) ?? [];
                            // const hierarquia = usuario.HierarquiaAcessoDomsge[0];
                            let temPropostaAprovada = false;
                            if (versoesStatus.length > 0) {
                              temPropostaAprovada = true;
                            }

                            // const temClientesDiferentes = (pessoa?.id ?? 0) !== (pessoaGnf?.id ?? 0);

                            const temClientesDiferentes =
                              (proposta?.pessoa_id ?? 0) !==
                              (proposta?.pessoa_gnf_id ?? 0);

                            return (
                              <CellMeasurer
                                cache={cache.current}
                                parent={parent}
                                key={key}
                                columnIndex={0}
                                rowIndex={index}
                              >
                                <div style={{ ...style }}>
                                  <ListGroupItem
                                    key={proposta.proposta_id}
                                    className="flex-column align-items-start mt-1 mb-1 pt-3 pb-0"
                                  >
                                    <div>
                                      <Row>
                                        <Col sm="4" className="mt-4">
                                          <Row className="align-items-center">
                                            <Col xs="2">
                                              <Button color="default" size="sm">
                                                {proposta.proposta_id}
                                              </Button>
                                            </Col>
                                            <Col xs="10">
                                              <h5 className="mb-0">
                                                Cadastro Inicial:{' '}
                                                {proposta.pessoa_gnf_id
                                                  ? `${proposta.pgnf_codigo_domsge} - ${proposta.pgnf_razao_social}`
                                                  : ''}
                                              </h5>
                                              <h6
                                                className="mb-0 fst-italic text-muted"
                                                hidden={
                                                  proposta.pgnf_codigo_domsge ===
                                                  proposta.codigoDomsge
                                                }
                                              >
                                                Definitivo Proposta:{' '}
                                                {proposta.pessoa_gnf_id
                                                  ? `${proposta.codigoDomsge} - ${proposta.razaoSocial}`
                                                  : ''}
                                              </h6>
                                            </Col>
                                          </Row>
                                        </Col>

                                        <Col sm="3">
                                          <div className="d-flex flex-column mx-3 mb-0 mt-4">
                                            <small>
                                              <strong>Localização:</strong>{' '}
                                              {proposta.municipio} /{' '}
                                              {proposta.uf}
                                            </small>

                                            <small>
                                              <strong>Usuário:</strong>{' '}
                                              {proposta.usuario_nome}
                                            </small>

                                            {proposta.pessoa_cargo_desc ? (
                                              <small>
                                                <strong>Função:</strong>{' '}
                                                {proposta.pessoa_cargo_desc}
                                              </small>
                                            ) : (
                                              <small> </small>
                                            )}
                                          </div>
                                        </Col>

                                        <Col sm="4">
                                          <div className="d-flex flex-column mx-3 mb-0 mt-4">
                                            {proposta.pessoa_razao &&
                                            !proposta.pessoa_interno ? (
                                              <small>
                                                <strong>Empresa:</strong>{' '}
                                                {proposta.pessoa_razao}
                                              </small>
                                            ) : (
                                              <small> </small>
                                            )}
                                            {proposta.pessoa_sup_razao ? (
                                              <small>
                                                <strong>Superior:</strong>{' '}
                                                {proposta.pessoa_sup_razao} |{' '}
                                                {proposta.pessoa_sup_cargo_desc}
                                              </small>
                                            ) : (
                                              <small> </small>
                                            )}
                                          </div>
                                        </Col>
                                        <Col>
                                          <div className="mt-4">
                                            <small>
                                              {new Intl.DateTimeFormat(
                                                'pt-BR',
                                              ).format(
                                                new Date(
                                                  proposta.created_at ?? 0,
                                                ),
                                              )}
                                            </small>
                                          </div>
                                        </Col>
                                      </Row>
                                    </div>
                                    <Row>
                                      <Col sm="1">
                                        <h6 hidden={!temClientesDiferentes}>
                                          {proposta.codigo_oportunidade_domsge
                                            ? `GNF ${proposta.codigo_oportunidade_domsge}`
                                            : ''}
                                        </h6>
                                      </Col>
                                    </Row>
                                    <CardHeader className="p-0 pt-2 pb-1">
                                      <Row>
                                        <Col xs="6">
                                          <h5 className="text-muted mb-0">
                                            Versões
                                          </h5>
                                        </Col>
                                      </Row>
                                    </CardHeader>
                                    <Table
                                      className="align-items-center table-flush"
                                      responsive
                                      striped
                                    >
                                      <thead className="thead-light">
                                        <tr>
                                          <th>#</th>
                                          <th>Status</th>
                                          <th>Valor frete</th>
                                          <th>Valor itens</th>
                                          <th>Valor serviço</th>
                                          <th>Valor final</th>
                                          <th>Gerada em</th>
                                          <th>&nbsp;</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {propostaVersoes.map(
                                          (propostaVersao: any) => {
                                            return (
                                              <tr key={propostaVersao.id}>
                                                <td className="py-2">
                                                  <Button
                                                    className="m-0"
                                                    color="primary"
                                                    type="button"
                                                    size="sm"
                                                    outline
                                                    onClick={() =>
                                                      navegarProposta(
                                                        proposta.proposta_id,
                                                        propostaVersao.versao_id,
                                                      )
                                                    }
                                                  >
                                                    <small>
                                                      {propostaVersao.versao}
                                                    </small>
                                                  </Button>
                                                </td>
                                                <td className="py-2">
                                                  <Tooltip
                                                    title={String(
                                                      propostaVersao.proposta_versao_observacao ??
                                                        '-',
                                                    )}
                                                  >
                                                    <Button
                                                      size="sm"
                                                      color="info"
                                                      outline
                                                    >
                                                      <FaInfoCircle />
                                                    </Button>
                                                  </Tooltip>
                                                  &nbsp;&nbsp;{' '}
                                                  {
                                                    propostaVersao.status_descricao
                                                  }
                                                </td>
                                                <td className="py-2">
                                                  {formataMoeda(
                                                    propostaVersao.valor_frete,
                                                  )}
                                                </td>
                                                <td className="py-2">
                                                  {formataMoeda(
                                                    propostaVersao.valor_itens,
                                                  )}
                                                </td>
                                                <td className="py-2">
                                                  {formataMoeda(
                                                    propostaVersao.valor_servico,
                                                  )}
                                                </td>
                                                <td className="py-2">
                                                  {formataMoeda(
                                                    propostaVersao.valor_final,
                                                  )}
                                                </td>
                                                <td className="py-2">
                                                  {new Intl.DateTimeFormat(
                                                    'pt-BR',
                                                  ).format(
                                                    new Date(
                                                      propostaVersao.created_at,
                                                    ),
                                                  )}
                                                </td>
                                                {!temPropostaAprovada && (
                                                  <td className="py-2">
                                                    <Button
                                                      className="btn-icon btn-2"
                                                      type="button"
                                                      title="Duplicar registro em nova versão da proposta"
                                                      onClick={() =>
                                                        duplicarRegistro(
                                                          proposta,
                                                          propostaVersao,
                                                        )
                                                      }
                                                      size="sm"
                                                    >
                                                      <FaCopy />
                                                    </Button>
                                                  </td>
                                                )}
                                              </tr>
                                            );
                                          },
                                        )}
                                      </tbody>
                                    </Table>
                                  </ListGroupItem>
                                </div>
                              </CellMeasurer>
                            );
                          }}
                        />
                      )}
                    </AutoSizer>
                  </div>
                )}
                {!isLoading && dados && dados.length === 0 && (
                  <Card className="shadow pt-3 pb-2 mt-1">
                    <h4 className="text-center">
                      Nenhuma proposta encontrada.
                    </h4>
                  </Card>
                )}
                {
                  // </InfiniteScroll>
                }
              </ListGroup>
            </>
          )}
        </CardBody>
      </Card>
    </>
  );
}
